import { HttpClient } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {CookieService} from 'ngx-cookie-service';
import {map} from 'rxjs/operators';
import {
  BankIdCollectHintCode,
  BankIdCollectStatus,
} from 'src/app/enums/BankIdEnums';
import {BankIdAuthenticateResponse} from '../../types/BankIdAuthenticateResponse';
import {BankIdCollectResponse} from '../../types/BankIdCollectResponse';
import {BankIdQrResponse} from '../../types/BankIdQrResponse';
import {BankidService} from '../bankid.service';
import {AppConfigService} from '../app-config.service';

export class MockBankidService extends BankidService {
  INTERVAL = 2;
  collected = 0;
  pno = '';

  constructor(
    protected appConfigService: AppConfigService,
    protected http: HttpClient,
    protected cookieService: CookieService
  ) {
    super(appConfigService, http, cookieService);
    console.log('Using mock bankid service');
  }

  protected callAuthenticate(): Observable<BankIdAuthenticateResponse> {
    console.log('Fake authenticate');
    return of({
      autoStartToken: 'cea1f21b-8953-435f-87b5-41265522a697',
      orderRef: 'eccfab8d-96aa-419e-9698-df9fb5208b19',
      qr: new Date().getTime().toString(),
    });
  }

  protected callCollect(): Observable<BankIdCollectResponse> {
    console.log('Fake collect');
    this.collected++;
    if (this.collected < this.INTERVAL) {
      return of({
        status: BankIdCollectStatus.pending,
        hintCode: BankIdCollectHintCode.started,
        token: null,
      });
    } else if (this.collected < this.INTERVAL * 2) {
      return of({
        status: BankIdCollectStatus.pending,
        hintCode: BankIdCollectHintCode.outStandingTransaction,
        token: null,
      });
    } else if (this.collected < this.INTERVAL * 3) {
      return of({
        status: BankIdCollectStatus.pending,
        hintCode: BankIdCollectHintCode.userSign,
        token: null,
      });
    } else {
      if (!this.pno) {
        this.pno = '191212121212';
      }
      console.log('Generating token for pno: ' + this.pno);
      return this.http
        .get<any>(
          this.appConfigService.appConfig.apiUrl +
            'members/debug/token?pno=' +
            this.pno
        )
        .pipe(
          map<any, any>(({token}) => {
            console.log('Token generated: ' + token);
            this.cookieService.set(
              'auth',
              token,
              365,
              '/',
              '.varden.se',
              true,
              'None'
            );
            return {
              status: BankIdCollectStatus.complete,
              hintCode: null,
              token,
            };
          })
        );
    }
  }

  protected callGetQr(): Observable<BankIdQrResponse> {
    console.log('Fake getQr');
    return of({
      qr: new Date().getTime().toString(),
    });
  }

  protected callCancel(): Observable<unknown> {
    console.log('Fake cancel');
    return of({});
  }

  public logout(): Observable<unknown> {
    document.cookie = 'auth=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/; domain=.varden.se; Secure; SameSite=None';
    return of({});
  }
}
